import styles from "../../index.module.scss";
import closebtnImg from "../../../../assets/images/close.png";
import { useContext } from "react";
import { UserContext } from "../../../../contexts/UserContext/UserContextProvider";

export const ChatContainerHeader = () => {
  const { setIsChatBotOpen } = useContext(UserContext);

  const handleCloseBtn = () => {
    setIsChatBotOpen(false);
  };

  return (
    <div className={styles.ChatBotHeader}>
      <div className={styles.ChatBotHeader__title}>
        <h2>Chat</h2>
      </div>
      <div className={styles["closeBtn"]} onClick={handleCloseBtn}>
        <img width="25px" src={closebtnImg} alt="close" />
      </div>
    </div>
  );
};
